import apiBase from '../utils/baseApi'

import type { Title } from '../pages/SearchPage/useMentorsSearch'
import type { MentorBase, MentorWithContext } from '../types/mentor'

export interface MentorsSearchParams {
  search: string
  size: number
}

export const mentorsSearch = async (
  params: MentorsSearchParams,
): Promise<MentorBase[] | undefined> => {
  try {
    const response = await apiBase.get<MentorBase[] | undefined>(
      '/v2/mentors',
      {
        params: {
          search: params.search,
          size: params.size,
        },
      },
    )
    return response.data
  } catch (error) {
    console.error('Error searching mentors:', error)
  }
}

export const universalMentorSearch = async (
  params: MentorsSearchParams,
): Promise<MentorBase[] | undefined> => {
  try {
    const response = await apiBase.get<MentorBase[] | undefined>(
      '/v2/mentors/draft-search',
      {
        params: {
          search: params.search,
          size: params.size,
        },
      },
    )
    return response.data
  } catch (error) {
    console.error('Error searching mentors:', error)
    throw error
  }
}

export interface IMentorByContextResult {
  data: MentorWithContext[]
}

export const getMentorByContext = async (
  id: string,
  scopeId: string,
  quantity: number,
): Promise<IMentorByContextResult> => {
  try {
    const response = await apiBase.get<IMentorByContextResult>(
      `/v2/scope/${scopeId}/contexts/${id}/mentor?quantity=${quantity}`,
    )

    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}

export interface ITitlesResponse {
  contexts: Title[]
  scopeId: string
}

export const getSearchTitles = async (
  query: string,
): Promise<ITitlesResponse> => {
  try {
    const response = await apiBase.post<ITitlesResponse>('/v2/contexts', {
      query,
    })
    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}

export interface IMentorPoolingResponse {
  success: boolean
  items: MentorWithContext[]
}

export const getMentorsPooling = async (
  ids: string[],
): Promise<IMentorPoolingResponse> => {
  try {
    const response = await apiBase.post<IMentorPoolingResponse>(
      '/v2/mentors/batch',
      { ids },
    )

    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}

interface QueryClassificationResponse {
  success: boolean
  classification: string
}

export const getQueryClassification = async (
  query: string,
): Promise<QueryClassificationResponse> => {
  try {
    const response = await apiBase.get<QueryClassificationResponse>(
      `v2/query-classifications?userQuery=${query}`,
    )

    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}

export interface HashTag {
  label: string
  query: string
}

interface HashtagsResponse {
  success: boolean
  data: HashTag[]
}

export const getHashtags = async (): Promise<HashtagsResponse> => {
  try {
    const response = await apiBase.get<HashtagsResponse>(
      `/v2/suggested-queries`,
    )

    return response.data
  } catch (error) {
    console.error('Error editing persona:', error)
    throw error
  }
}
